import React, { useRef, useState } from "react";
import { Button, Input, Space, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import Style from "./CustomerTable.module.scss";
import {
  Check,
  Check2,
  PencilSquare,
  Wallet,
  XLg,
} from "react-bootstrap-icons";

const CustomerTable = ({ data, showAddress }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    {
      title: "نام",
      dataIndex: "first_name",
      key: "first_name",
      width: "11%",
      ...getColumnSearchProps("first_name", "نام "),
      render: (text, record) => (
        <p className={Style.nameField} onClick={() => showAddress(5, record)}>
          {text}
        </p>
      ),
    },
    {
      title: "نام خانوادگی",
      dataIndex: "last_name",
      key: "last_name",
      width: "11%",
      ...getColumnSearchProps("last_name", "نام خانوادگی "),
      render: (text, record) => (
        <p className={Style.nameField} onClick={() => showAddress(5, record)}>
          {text}
        </p>
      ),
    },
    {
      title: "آیدی مشتری",
      dataIndex: "userId",
      key: "userId",
      width: "11%",
      ...getColumnSearchProps("userId", "آیدی کاربر "),
    },
    {
      title: "شماره تلفن",
      dataIndex: "phone",
      key: "phone",
      width: "12%",
      ...getColumnSearchProps("phone", "شماره تلفن"),
    },
    {
      title: "زمان ثبت نام",
      dataIndex: "signUpDate",
      key: "signUpDate",
      width: "11%",
    },
    {
      title: "لیست آدرس",
      dataIndex: "address",
      key: "address",
      width: "11%",
      render: (text, record) => (
        <button
          onClick={() => showAddress(1, record)}
          className={Style.addresBtn}
        >
          آدرس
        </button>
      ),
    },
    {
      title: "زیرمجموعه",
      dataIndex: "refCount",
      key: "refCount",
      width: "11%",
      render: (text, record) => (
        <button
          onClick={() => showAddress(6, record)}
          className={Style.addresBtn}
        >
          {record.refCount}
        </button>
      ),
    },
    {
      title: " کددعوت  ",
      dataIndex: "myRef",
      key: "myRef",
      width: "10%",
    },
    {
      title: " کدمعرف  ",
      dataIndex: "refInvite",
      key: "refInvite",
      width: "10%",
    },
    {
      title: "امتیازات",
      dataIndex: "scores",
      key: "scores",
      width: "10%",
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      width: "16%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => showAddress(2, record)}
            className={Style.scoreBtn}
          >
            {" "}
            <span>+</span>امتیاز
          </button>
          <button
            onClick={() => showAddress(9, record)}
            className={Style.moneyBtn}
          >
            {" "}
            <span>+</span>پول
          </button>
          <button
            onClick={() => showAddress(3, record)}
            className={Style.editBtn}
          >
            <PencilSquare />
          </button>
          {record.status === "1" ? (
            <button
              onClick={() => showAddress(4, record)}
              className={Style.deleteBtn}
            >
              {" "}
              <XLg />{" "}
            </button>
          ) : (
            <button
              onClick={() => showAddress(4, record)}
              className={Style.activeBtn}
            >
              <Check2 />
            </button>
          )}
          <button
            onClick={() => showAddress(8, record)}
            className={Style.walletBtn}
          >
            <Wallet />
          </button>
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ pageSize: 5 }}
        columns={columns}
        dataSource={data}
        responsive={true}
        scroll={{x:1500, y: 300 }}
      />
    </div>
  );
};

export default CustomerTable;
